import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Messages Redux States
import { GET_CSAT } from "./actionTypes";
import { headerError, setCsat } from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getCsat() {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_URL}/csat/user`
    );

    if (response.status === 200) {
      yield put(setCsat({ lastUpdate: new Date(), ...response?.data?.data }));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "Get csat error";
    yield put(headerError({ action: "get_csat", message: message }));
  }
}

export function* watchGetCsat() {
  yield takeEvery(GET_CSAT, getCsat);
}
function* authSaga() {
  yield all([fork(watchGetCsat)]);
}

export default authSaga;
